import styled, { css } from 'styled-components';
import { mq, getSpace, getGridSpan, getGridSpans } from '../../../stylesheets/tools';

/* TODO: Clean up */
const StyledImageText = styled.div`
  position: relative;
  width: 100%;
  margin: ${getSpace('xl')} 0;
  display: block;

  .content__container {
    ${mq('l')} {
      display: flex;
      flex-direction: ${props => (props.alignment === 'left' ? 'row-reverse' : 'row')};
    }
  }

  .image__container {
    position: relative;
    margin-top: ${getSpace('l')};

    ${mq('l')} {
      margin-top: 0;
    }
  }

  .image__wrapper,
  .image__outer {
    position: relative;
  }

  .image__background {
    position: absolute;
    background: ${props => (props.hasBackground ? props.theme.siteTheme.primary : '')};

    &--mobile {
      ${mq('l')} {
        display: none;
      }
    }

    &--desktop {
      display: none;

      ${mq('l')} {
        display: block;
      }
    }
  }

  .image__inner {
    position: relative;
    width: 100%;
    height: 0;
    display: block;

    img {
      width: 100%;
      height: auto;
    }
  }

  .image__description {
    margin: 20px 0;
  }

  .image__caption,
  .image__credits {
    position: relative;
    margin: 0;
    z-index: 1;
  }

  .text__headlines {
    ${getGridSpans('width', { m: 11, l: 6 })}

    position: relative;
    z-index: 1;
    margin-bottom: 20px;

    h2 {
      margin-top: 15px;
    }

    ${mq('l')} {
      margin-bottom: 40px;
      padding-top: 20px;
    }
  }

  .text__copy {
    position: relative;
    z-index: 1;
    margin-left: ${getGridSpan(1, 'spread')};
    ${getGridSpans('width', { m: 10 })}
  }

  ${props =>
    props.imageFormat === 'landscape' &&
    css`
      .image__container {
        ${getGridSpans('width', { l: 6 })}
      }

      .image__background {
        top: 50%;
        transform: translateY(-50%);
        height: calc(100% + 160px);
        ${getGridSpans('width', { s: [11, 'spread'], m: [9, 'wide'], l: 5 })}

        ${mq('l')} {
          height: 580px;
          top: ${props.hasHeadlines ? '55px' : '-100px'};
          transform: translateY(0);
        }
      }

      .image__outer {
        ${getGridSpans('width', { s: 12, m: [10, 'wide'], l: 12 })}
      }

      .image__inner {
        padding-bottom: calc(3 / 4 * 100%);
      }

      .text__copy {
        ${getGridSpans('width', { l: 4 })}
      }

      ${props.alignment === 'left' &&
        css`
          .image__wrapper {
            left: -46px;

            ${mq('l')} {
              left: 0;
            }
          }

          ${mq('l')} {
            .image__background {
              left: ${getGridSpan(-2, 'spread')};
            }

            .text__headlines {
              margin-left: ${getGridSpan(6, 'spread')};
            }

            .image__caption,
            .image__credits {
              margin-left: ${getGridSpan(2, 'spread')};
            }
          }
        `}

      ${props.alignment === 'right' &&
        css`
          .image__wrapper {
            right: -46px;

            ${mq('l')} {
              right: 0;
            }
          }

          .image__background {
            ${getGridSpans('margin-left', { s: 1, m: [3, 'wide'] })}
            ${getGridSpans('right', { l: [-2, 'spread'] })}
          }

          .image__outer {
            ${getGridSpans('margin-left', { m: [2, 'wide'] })}

            ${mq('m')} {
              margin-left: 0;
            }
          }

          .image__caption,
          .image__credits {
            ${getGridSpans('margin-left', { m: [2, 'spread'] })}
          }
        `}
    `};

  ${props =>
    props.imageFormat === 'portrait' &&
    css`
      margin-top: ${props.hasHeadlines ? getSpace('xl') : '130px'};
      .image__container {
        ${getGridSpans('width', { l: 6 })}
      }

      .image__background {
        top: -80px;
        padding-bottom: calc(3 / 4 * 100%);
        height: 0;
        width: calc(100% + 60px);

        ${mq('l')} {
          padding-bottom: 0;
          top: ${props.hasHeadlines ? '0' : '-130px'};
          height: 500px;
          width: ${getGridSpan(8)};
        }
      }

      .image__outer {
        ${getGridSpans('width', { s: 10, m: 8 })}

        ${mq('l')} {
          margin-top: -80px;
          width: 100%;
        }
      }

      .image__inner {
        padding-bottom: calc(4 / 3 * 100%);
      }

      .text__copy {
        ${getGridSpans('width', { l: 5 })}
      }

      ${props.alignment === 'left' &&
        css`
          .image__wrapper {
            left: -46px;

            ${mq('l')} {
              left: 0;
            }
          }

          .image__background {
            ${getGridSpans('left', { l: [-2, 'spread'] })}
          }

          .image__outer {
            ${getGridSpans('padding-right', { l: [2, 'spread'] })}
          }

          .image__caption,
          .image__credits {
            ${getGridSpans('margin-left', { l: [2, 'spread'] })}
          }

          .text__headlines {
            ${getGridSpans('margin-left', { l: [6, 'spread'] })}
          }
        `}

      ${props.alignment === 'right' &&
        css`
          .image__background {
            left: -46px;

            ${mq('l')} {
              left: auto;
              right: ${getGridSpan(-2, 'spread')};
            }
          }

          .image__outer {
            ${getGridSpans('margin-left', { s: [2, 'spread'], m: [4, 'spread'] })}
            right: -46px;

            ${mq('l')} {
              right: 0;
              margin-left: 0;
              padding-left: ${getGridSpan(2, 'spread')};
            }
          }

          .image__caption,
          .image__credits {
            ${getGridSpans('margin-left', { m: [2, 'spread'] })}
            ${mq('l')} {
              margin-left: 0;
            }
          }
        `}
    `};
`;

export default StyledImageText;
